// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__mKvL-","ldsRipple":"Spinner_ldsRipple__IIV8z","lds-ripple":"Spinner_lds-ripple__b1kAC"};